import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  bottomContainer: css`
    display: flex;
    z-index: 2;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    padding: 24px 16px 32px 16px;
    position: sticky;
    background-color: ${colors.white};
    bottom: 0;
    width: 100%;
    box-shadow: rgba(0, 0, 0, 0.04) 0px 0px 0px -1px, rgba(0, 0, 0, 0.15) 0px -2px 4px 0px,
      rgba(0, 0, 0, 0.04) 0px 3px 3px -1.5px, rgba(0, 0, 0, 0.04) 0px 5px 2px -4px,
      rgba(0, 0, 0, 0.04) 0px -3px 8px 3px, rgba(0, 0, 0, 0.04) 0px 24px 24px -12px;
    font-size: 14px;
    color: ${colors.prussian};
  `,
  button: css`
    max-width: 812px;
    width: 100%;
  `,
};

export default styles;
